/* tslint:disable */
/* eslint-disable */
/**
 * Radianse Documents API - .Net 6
 * <b>Build:</b>Radianse.App.Documents_main_2023.9.11.2
 *
 * The version of the OpenAPI document: UserApi_V1
 * Contact: support@radianse.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Configuration } from "./configuration";
import globalAxios, {
  AxiosPromise,
  AxiosInstance,
  AxiosRequestConfig,
} from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "./common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "./base";

/**
 * DataUrl used with photo url parsing
 * @export
 * @interface IDataUrl
 */
export interface IDataUrl {
  /**
   * The encoded data or the path to the blob
   * @type {string}
   * @memberof IDataUrl
   */
  data: string;
  /**
   * The media type. (.i.e text/plain, image/gif, image/jpg, ...)
   * @type {string}
   * @memberof IDataUrl
   */
  mediaType: string;
  /**
   * Message if there was an error uploading the data
   * @type {string}
   * @memberof IDataUrl
   */
  errorMessage?: string | null;
  /**
   * Size of the file if available
   * @type {number}
   * @memberof IDataUrl
   */
  size?: number | null;
}
/**
 * Document class
 * @export
 * @interface IDocument
 */
export interface IDocument {
  /**
   * ID for storage
   * @type {string}
   * @memberof IDocument
   */
  id?: string | null;
  /**
   * Category
   * @type {string}
   * @memberof IDocument
   */
  category?: string;
  /**
   * SubCategory
   * @type {string}
   * @memberof IDocument
   */
  subCategory?: string;
  /**
   * Partition key is a constant value since documents are customer wide
   * @type {string}
   * @memberof IDocument
   */
  partitionKey?: string | null;
  /**
   * Document may be revised over time
   * @type {Array<IDocumentRevision>}
   * @memberof IDocument
   */
  revisions?: Array<IDocumentRevision>;
  /**
   * The name of the document
   * @type {string}
   * @memberof IDocument
   */
  name: string;
  /**
   *
   * @type {IDocumentType}
   * @memberof IDocument
   */
  documentType: IDocumentType;
  /**
   *
   * @type {IDocumentGroup}
   * @memberof IDocument
   */
  documentGroup?: IDocumentGroup;
  /**
   * Deleted
   * @type {boolean}
   * @memberof IDocument
   */
  deleted?: boolean;
}
/**
 *
 * @export
 * @interface IDocumentDto
 */
export interface IDocumentDto {
  /**
   * Document may be revised over time
   * @type {Array<IDocumentRevision>}
   * @memberof IDocumentDto
   */
  revisions?: Array<IDocumentRevision>;
  /**
   * The name of the document
   * @type {string}
   * @memberof IDocumentDto
   */
  name: string;
  /**
   *
   * @type {IDocumentType}
   * @memberof IDocumentDto
   */
  documentType: IDocumentType;
  /**
   *
   * @type {IDocumentGroup}
   * @memberof IDocumentDto
   */
  documentGroup?: IDocumentGroup;
  /**
   * Deleted
   * @type {boolean}
   * @memberof IDocumentDto
   */
  deleted?: boolean;
}
/**
 * DocumentGroup
 * @export
 * @enum {string}
 */

export const IDocumentGroup = {
  Schedule: "Schedule",
} as const;

export type IDocumentGroup = typeof IDocumentGroup[keyof typeof IDocumentGroup];

/**
 *
 * @export
 * @interface IDocumentIRadianseResult
 */
export interface IDocumentIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IDocumentIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {IDocument}
   * @memberof IDocumentIRadianseResult
   */
  data?: IDocument;
  /**
   *
   * @type {string}
   * @memberof IDocumentIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IDocumentIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IDocumentIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IDocumentIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IDocumentIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IDocumentIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IDocumentIRadianseResultSuccess
 */
export interface IDocumentIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IDocumentIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {IDocument}
   * @memberof IDocumentIRadianseResultSuccess
   */
  data: IDocument;
  /**
   *
   * @type {string}
   * @memberof IDocumentIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IDocumentIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IDocumentIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IDocumentIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IDocumentIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IDocumentIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 * Document revision
 * @export
 * @interface IDocumentRevision
 */
export interface IDocumentRevision {
  /**
   * Document revision id
   * @type {string}
   * @memberof IDocumentRevision
   */
  id?: string | null;
  /**
   * Name to display for document
   * @type {string}
   * @memberof IDocumentRevision
   */
  name: string;
  /**
   * The date the document should activate
   * @type {string}
   * @memberof IDocumentRevision
   */
  activeDate?: string;
  /**
   *
   * @type {IDataUrl}
   * @memberof IDocumentRevision
   */
  documentDataUrl?: IDataUrl;
  /**
   *
   * @type {IDataUrl}
   * @memberof IDocumentRevision
   */
  documentData?: IDataUrl;
  /**
   *
   * @type {IDataUrl}
   * @memberof IDocumentRevision
   */
  documentTemplate?: IDataUrl;
  /**
   * The document must be signed every {renewPeriod} days
   * @type {number}
   * @memberof IDocumentRevision
   */
  renewPeriod?: number | null;
  /**
   * If there is a time limit on a document, then one may not schedule again within this limit.
   * @type {number}
   * @memberof IDocumentRevision
   */
  timeRestriction?: number | null;
  /**
   *
   * @type {ILanguage}
   * @memberof IDocumentRevision
   */
  language: ILanguage;
  /**
   * Is document active or deleted?
   * @type {boolean}
   * @memberof IDocumentRevision
   */
  deleted?: boolean;
}
/**
 *
 * @export
 * @interface IDocumentRevisionDto
 */
export interface IDocumentRevisionDto {
  /**
   * Name
   * @type {string}
   * @memberof IDocumentRevisionDto
   */
  name: string;
  /**
   * The date the document should activate
   * @type {string}
   * @memberof IDocumentRevisionDto
   */
  activeDate?: string;
  /**
   *
   * @type {IDataUrl}
   * @memberof IDocumentRevisionDto
   */
  documentDataUrl?: IDataUrl;
  /**
   *
   * @type {IDataUrl}
   * @memberof IDocumentRevisionDto
   */
  documentData?: IDataUrl;
  /**
   *
   * @type {IDataUrl}
   * @memberof IDocumentRevisionDto
   */
  documentTemplate?: IDataUrl;
  /**
   * The document must be signed every {renewPeriod} days
   * @type {number}
   * @memberof IDocumentRevisionDto
   */
  renewPeriod?: number | null;
  /**
   * If there is a time limit on a document, then one may not schedule again within this limit.
   * @type {number}
   * @memberof IDocumentRevisionDto
   */
  timeRestriction?: number | null;
  /**
   *
   * @type {ILanguage}
   * @memberof IDocumentRevisionDto
   */
  language: ILanguage;
  /**
   * Is document active or deleted?
   * @type {boolean}
   * @memberof IDocumentRevisionDto
   */
  deleted?: boolean;
}
/**
 *
 * @export
 * @interface IDocumentRevisionIRadianseResult
 */
export interface IDocumentRevisionIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IDocumentRevisionIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {IDocumentRevision}
   * @memberof IDocumentRevisionIRadianseResult
   */
  data?: IDocumentRevision;
  /**
   *
   * @type {string}
   * @memberof IDocumentRevisionIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IDocumentRevisionIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentRevisionIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IDocumentRevisionIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IDocumentRevisionIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IDocumentRevisionIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IDocumentRevisionIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentRevisionIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentRevisionIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IDocumentRevisionIRadianseResultSuccess
 */
export interface IDocumentRevisionIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IDocumentRevisionIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {IDocumentRevision}
   * @memberof IDocumentRevisionIRadianseResultSuccess
   */
  data: IDocumentRevision;
  /**
   *
   * @type {string}
   * @memberof IDocumentRevisionIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IDocumentRevisionIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentRevisionIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IDocumentRevisionIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IDocumentRevisionIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IDocumentRevisionIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IDocumentRevisionIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentRevisionIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentRevisionIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 * A signed document revision
 * @export
 * @interface IDocumentRevisionSigning
 */
export interface IDocumentRevisionSigning {
  /**
   * The UTC date the document was signed or questions answered
   * @type {string}
   * @memberof IDocumentRevisionSigning
   */
  createDate?: string;
  /**
   * The tenant id of the place the document was signed at. This is not necessarily the  person\'s home tenant/club.
   * @type {string}
   * @memberof IDocumentRevisionSigning
   */
  tenantIdOfSigning: string;
  /**
   * The name of the document revision
   * @type {string}
   * @memberof IDocumentRevisionSigning
   */
  name: string;
  /**
   * There may be multiple revisions of Document.Id. DocumentRevisionId points the  Document.Revisions.Id the person signed. The Document class has a list of document revisions.
   * @type {string}
   * @memberof IDocumentRevisionSigning
   */
  documentRevisionId: string;
  /**
   * The score calculated from the answers weighted values.
   * @type {number}
   * @memberof IDocumentRevisionSigning
   */
  score?: number | null;
  /**
   * The result after evaluating the answers to the questions.
   * @type {string}
   * @memberof IDocumentRevisionSigning
   */
  result?: string | null;
  /**
   * A boolean to indicate if the requirements of the document have been met
   * @type {boolean}
   * @memberof IDocumentRevisionSigning
   */
  isValidated?: boolean | null;
  /**
   * The reason the validation may have failed
   * @type {string}
   * @memberof IDocumentRevisionSigning
   */
  validationReason?: string | null;
  /**
   *
   * @type {IDataUrl}
   * @memberof IDocumentRevisionSigning
   */
  documentDataUrl?: IDataUrl;
  /**
   *
   * @type {IDataUrl}
   * @memberof IDocumentRevisionSigning
   */
  documentData?: IDataUrl;
  /**
   *
   * @type {IDataUrl}
   * @memberof IDocumentRevisionSigning
   */
  documentTemplate?: IDataUrl;
  /**
   *
   * @type {IDataUrl}
   * @memberof IDocumentRevisionSigning
   */
  documentPdf?: IDataUrl;
  /**
   * The handlebars template data.
   * @type {any}
   * @memberof IDocumentRevisionSigning
   */
  templateData?: any;
  /**
   *
   * @type {ILanguage}
   * @memberof IDocumentRevisionSigning
   */
  language: ILanguage;
  /**
   * If document is being signed on behalf of another individual. Store the user\'s UserProfileId here and validate the user has documentssigning_onbehalfof permissions
   * @type {string}
   * @memberof IDocumentRevisionSigning
   */
  userProfileIdOnBehalfOf?: string | null;
  /**
   * If true, the document has not been uploaded to blob yet
   * @type {boolean}
   * @memberof IDocumentRevisionSigning
   */
  isProcessing?: boolean | null;
  /**
   * Is document revision active or deleted?
   * @type {boolean}
   * @memberof IDocumentRevisionSigning
   */
  deleted?: boolean;
}
/**
 * A signed document revision
 * @export
 * @interface IDocumentRevisionSigningDto
 */
export interface IDocumentRevisionSigningDto {
  /**
   * The UTC date the document was signed or questions answered
   * @type {string}
   * @memberof IDocumentRevisionSigningDto
   */
  createDate?: string | null;
  /**
   *
   * @type {IDataUrl}
   * @memberof IDocumentRevisionSigningDto
   */
  documentDataUrl?: IDataUrl;
  /**
   *
   * @type {IDataUrl}
   * @memberof IDocumentRevisionSigningDto
   */
  documentData?: IDataUrl;
  /**
   *
   * @type {IDataUrl}
   * @memberof IDocumentRevisionSigningDto
   */
  documentTemplate?: IDataUrl;
  /**
   *
   * @type {IDataUrl}
   * @memberof IDocumentRevisionSigningDto
   */
  documentPdf?: IDataUrl;
  /**
   * The handlebars template data.
   * @type {any}
   * @memberof IDocumentRevisionSigningDto
   */
  templateData?: any | null;
  /**
   *
   * @type {ILanguage}
   * @memberof IDocumentRevisionSigningDto
   */
  language?: ILanguage;
  /**
   * If document is being signed on behalf of another individual. Store the user\'s UserProfileId here and validate the user has documentssigning_onbehalfof permissions
   * @type {string}
   * @memberof IDocumentRevisionSigningDto
   */
  userProfileIdOnBehalfOf?: string | null;
}
/**
 *
 * @export
 * @interface IDocumentRevisionSigningIRadianseResult
 */
export interface IDocumentRevisionSigningIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IDocumentRevisionSigningIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {IDocumentRevisionSigning}
   * @memberof IDocumentRevisionSigningIRadianseResult
   */
  data?: IDocumentRevisionSigning;
  /**
   *
   * @type {string}
   * @memberof IDocumentRevisionSigningIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IDocumentRevisionSigningIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentRevisionSigningIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IDocumentRevisionSigningIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IDocumentRevisionSigningIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IDocumentRevisionSigningIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IDocumentRevisionSigningIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentRevisionSigningIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentRevisionSigningIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IDocumentRevisionSigningIRadianseResultSuccess
 */
export interface IDocumentRevisionSigningIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IDocumentRevisionSigningIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {IDocumentRevisionSigning}
   * @memberof IDocumentRevisionSigningIRadianseResultSuccess
   */
  data: IDocumentRevisionSigning;
  /**
   *
   * @type {string}
   * @memberof IDocumentRevisionSigningIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IDocumentRevisionSigningIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentRevisionSigningIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IDocumentRevisionSigningIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IDocumentRevisionSigningIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IDocumentRevisionSigningIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IDocumentRevisionSigningIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentRevisionSigningIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentRevisionSigningIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 * Sign a document
 * @export
 * @interface IDocumentSigning
 */
export interface IDocumentSigning {
  /**
   * Category
   * @type {string}
   * @memberof IDocumentSigning
   */
  category?: string;
  /**
   * SubCategory
   * @type {string}
   * @memberof IDocumentSigning
   */
  subCategory?: string;
  /**
   * Document ID
   * @type {string}
   * @memberof IDocumentSigning
   */
  id?: string;
  /**
   * PartitionKey = PersonId. This would be Member.Id for pf.
   * @type {string}
   * @memberof IDocumentSigning
   */
  partitionKey?: string;
  /**
   * The person\'s id that signed the document. Example, for a pf member it would be Member.id
   * @type {string}
   * @memberof IDocumentSigning
   */
  personId?: string;
  /**
   * The Document.id
   * @type {string}
   * @memberof IDocumentSigning
   */
  documentId?: string;
  /**
   * Contains documents that the user signed and answered the questions questions.
   * @type {Array<IDocumentRevisionSigning>}
   * @memberof IDocumentSigning
   */
  revisionsSigned?: Array<IDocumentRevisionSigning>;
  /**
   * If the requirement of the latest active document revision passed
   * @type {boolean}
   * @memberof IDocumentSigning
   */
  isValidatedLatestRevision?: boolean | null;
  /**
   * The reason the validation may have failed
   * @type {string}
   * @memberof IDocumentSigning
   */
  validationReasonLastestRevision?: string | null;
  /**
   * The latest active document revision id
   * @type {string}
   * @memberof IDocumentSigning
   */
  activeDocumentRevisionId?: string;
  /**
   * Is document active or deleted?
   * @type {boolean}
   * @memberof IDocumentSigning
   */
  deleted?: boolean;
}
/**
 *
 * @export
 * @interface IDocumentSigningIRadianseResult
 */
export interface IDocumentSigningIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IDocumentSigningIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {IDocumentSigning}
   * @memberof IDocumentSigningIRadianseResult
   */
  data?: IDocumentSigning;
  /**
   *
   * @type {string}
   * @memberof IDocumentSigningIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IDocumentSigningIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentSigningIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IDocumentSigningIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IDocumentSigningIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IDocumentSigningIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IDocumentSigningIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentSigningIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentSigningIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IDocumentSigningIRadianseResultSuccess
 */
export interface IDocumentSigningIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IDocumentSigningIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {IDocumentSigning}
   * @memberof IDocumentSigningIRadianseResultSuccess
   */
  data: IDocumentSigning;
  /**
   *
   * @type {string}
   * @memberof IDocumentSigningIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IDocumentSigningIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentSigningIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IDocumentSigningIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IDocumentSigningIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IDocumentSigningIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IDocumentSigningIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentSigningIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentSigningIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IDocumentSigningListIRadianseResult
 */
export interface IDocumentSigningListIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IDocumentSigningListIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {Array<IDocumentSigning>}
   * @memberof IDocumentSigningListIRadianseResult
   */
  data?: Array<IDocumentSigning> | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentSigningListIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IDocumentSigningListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentSigningListIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IDocumentSigningListIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IDocumentSigningListIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IDocumentSigningListIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IDocumentSigningListIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentSigningListIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentSigningListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IDocumentSigningListIRadianseResultSuccess
 */
export interface IDocumentSigningListIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IDocumentSigningListIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {Array<IDocumentSigning>}
   * @memberof IDocumentSigningListIRadianseResultSuccess
   */
  data: Array<IDocumentSigning>;
  /**
   *
   * @type {string}
   * @memberof IDocumentSigningListIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IDocumentSigningListIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentSigningListIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IDocumentSigningListIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IDocumentSigningListIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IDocumentSigningListIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IDocumentSigningListIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentSigningListIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IDocumentSigningListIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const IDocumentType = {
  File: "File",
  QuestionWeighted: "QuestionWeighted",
  Signature: "Signature",
} as const;

export type IDocumentType = typeof IDocumentType[keyof typeof IDocumentType];

/**
 * A single document which does not contain revisions
 * @export
 * @interface IFileProps
 */
export interface IFileProps {
  /**
   * Category
   * @type {string}
   * @memberof IFileProps
   */
  category?: string;
  /**
   * SubCategory
   * @type {string}
   * @memberof IFileProps
   */
  subCategory?: string;
  /**
   * Document ID
   * @type {string}
   * @memberof IFileProps
   */
  id?: string | null;
  /**
   * PartitionKey = PersonId. This would be Member.Id for pf.
   * @type {string}
   * @memberof IFileProps
   */
  partitionKey?: string | null;
  /**
   * The id of the file
   * @type {string}
   * @memberof IFileProps
   */
  fileId?: string;
  /**
   * The identity of the entity that uploaded the document.
   * @type {string}
   * @memberof IFileProps
   */
  identityId?: string;
  /**
   * The UTC date the document was signed or questions answered
   * @type {string}
   * @memberof IFileProps
   */
  createDate?: string;
  /**
   * The tenant id of the place the document was uploaded at. This is not necessarily the  person\'s home tenant/club.
   * @type {string}
   * @memberof IFileProps
   */
  tenantId: string;
  /**
   * The name of the document
   * @type {string}
   * @memberof IFileProps
   */
  name: string;
  /**
   *
   * @type {IDataUrl}
   * @memberof IFileProps
   */
  fileDataUrl?: IDataUrl;
  /**
   *
   * @type {ILanguage}
   * @memberof IFileProps
   */
  language?: ILanguage;
  /**
   * If true, the document has not been uploaded to blob yet
   * @type {boolean}
   * @memberof IFileProps
   */
  isProcessing?: boolean | null;
  /**
   * Is document active or deleted?
   * @type {boolean}
   * @memberof IFileProps
   */
  deleted?: boolean;
}
/**
 * A single document which does not contain revisions
 * @export
 * @interface IFilePropsDto
 */
export interface IFilePropsDto {
  /**
   * The file identifier
   * @type {string}
   * @memberof IFilePropsDto
   */
  fileId?: string;
  /**
   * The id of the identity that uploaded the file. Example, for a pf member it would be Member.id
   * @type {string}
   * @memberof IFilePropsDto
   */
  identityId?: string;
  /**
   * The UTC date the document was uploaded
   * @type {string}
   * @memberof IFilePropsDto
   */
  createDate?: string | null;
  /**
   * The tenant id of the place the document was uploaded at. This is not necessarily the  person\'s home tenant/club.
   * @type {string}
   * @memberof IFilePropsDto
   */
  tenantId?: string | null;
  /**
   * The name of the document
   * @type {string}
   * @memberof IFilePropsDto
   */
  name: string;
  /**
   *
   * @type {IDataUrl}
   * @memberof IFilePropsDto
   */
  fileDataUrl?: IDataUrl;
  /**
   *
   * @type {ILanguage}
   * @memberof IFilePropsDto
   */
  language?: ILanguage;
  /**
   * If true, the document has not been uploaded to blob yet
   * @type {boolean}
   * @memberof IFilePropsDto
   */
  isProcessing?: boolean | null;
}
/**
 *
 * @export
 * @interface IFilePropsIRadianseResult
 */
export interface IFilePropsIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IFilePropsIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {IFileProps}
   * @memberof IFilePropsIRadianseResult
   */
  data?: IFileProps;
  /**
   *
   * @type {string}
   * @memberof IFilePropsIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IFilePropsIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IFilePropsIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IFilePropsIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IFilePropsIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IFilePropsIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IFilePropsIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IFilePropsIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IFilePropsIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IFilePropsIRadianseResultSuccess
 */
export interface IFilePropsIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IFilePropsIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {IFileProps}
   * @memberof IFilePropsIRadianseResultSuccess
   */
  data: IFileProps;
  /**
   *
   * @type {string}
   * @memberof IFilePropsIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IFilePropsIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IFilePropsIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IFilePropsIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IFilePropsIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IFilePropsIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IFilePropsIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IFilePropsIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IFilePropsIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IFilePropsListIRadianseResult
 */
export interface IFilePropsListIRadianseResult {
  /**
   *
   * @type {number}
   * @memberof IFilePropsListIRadianseResult
   */
  count?: number | null;
  /**
   *
   * @type {Array<IFileProps>}
   * @memberof IFilePropsListIRadianseResult
   */
  data?: Array<IFileProps> | null;
  /**
   *
   * @type {string}
   * @memberof IFilePropsListIRadianseResult
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IFilePropsListIRadianseResult
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IFilePropsListIRadianseResult
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IFilePropsListIRadianseResult
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IFilePropsListIRadianseResult
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IFilePropsListIRadianseResult
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IFilePropsListIRadianseResult
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IFilePropsListIRadianseResult
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IFilePropsListIRadianseResult
   */
  continuationToken?: string | null;
}
/**
 *
 * @export
 * @interface IFilePropsListIRadianseResultSuccess
 */
export interface IFilePropsListIRadianseResultSuccess {
  /**
   *
   * @type {number}
   * @memberof IFilePropsListIRadianseResultSuccess
   */
  count?: number | null;
  /**
   *
   * @type {Array<IFileProps>}
   * @memberof IFilePropsListIRadianseResultSuccess
   */
  data: Array<IFileProps>;
  /**
   *
   * @type {string}
   * @memberof IFilePropsListIRadianseResultSuccess
   */
  detail: string;
  /**
   *
   * @type {{ [key: string]: Array<string>; }}
   * @memberof IFilePropsListIRadianseResultSuccess
   */
  errors?: { [key: string]: Array<string> } | null;
  /**
   *
   * @type {string}
   * @memberof IFilePropsListIRadianseResultSuccess
   */
  instance?: string | null;
  /**
   *
   * @type {number}
   * @memberof IFilePropsListIRadianseResultSuccess
   */
  status?: number;
  /**
   *
   * @type {boolean}
   * @memberof IFilePropsListIRadianseResultSuccess
   */
  success?: boolean;
  /**
   *
   * @type {string}
   * @memberof IFilePropsListIRadianseResultSuccess
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof IFilePropsListIRadianseResultSuccess
   */
  traceId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IFilePropsListIRadianseResultSuccess
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof IFilePropsListIRadianseResultSuccess
   */
  continuationToken?: string | null;
}
/**
 * A single document which does not contain revisions
 * @export
 * @interface IFilePropsPostDto
 */
export interface IFilePropsPostDto {
  /**
   * The id of the identity that uploaded the file. Example, for a pf member it would be Member.id
   * @type {string}
   * @memberof IFilePropsPostDto
   */
  identityId?: string;
  /**
   * The UTC date the document was uploaded
   * @type {string}
   * @memberof IFilePropsPostDto
   */
  createDate?: string | null;
  /**
   * The tenant id of the place the document was uploaded at. This is not necessarily the  person\'s home tenant/club.
   * @type {string}
   * @memberof IFilePropsPostDto
   */
  tenantId?: string | null;
  /**
   * The name of the document
   * @type {string}
   * @memberof IFilePropsPostDto
   */
  name: string;
  /**
   *
   * @type {IDataUrl}
   * @memberof IFilePropsPostDto
   */
  fileDataUrl?: IDataUrl;
  /**
   *
   * @type {ILanguage}
   * @memberof IFilePropsPostDto
   */
  language?: ILanguage;
}
/**
 *
 * @export
 * @interface IIRadianseRequestContext
 */
export interface IIRadianseRequestContext {
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  clientAccessToken?: string;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  acceptLanguage?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  ipAddress?: string;
  /**
   *
   * @type {boolean}
   * @memberof IIRadianseRequestContext
   */
  isUserRequest?: boolean;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToCustomerId?: string;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToGroupId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  scopeToTenantId?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  userAccessToken?: string;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  detail?: string | null;
  /**
   *
   * @type {string}
   * @memberof IIRadianseRequestContext
   */
  identityProfileId?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  clientRoles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  customerRoles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  groupRoles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  tenantRoles?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  customerPermissions?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  groupPermissions?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof IIRadianseRequestContext
   */
  tenantPermissions?: Array<string> | null;
}
/**
 * Language as defined by ISO 639-1
 * @export
 * @interface ILanguage
 */
export interface ILanguage {
  /**
   * The ISO 639-1 two-letter code for the language of the current System.Globalization.CultureInfo.
   * @type {string}
   * @memberof ILanguage
   */
  code: string;
  /**
   * The culture name in the format languagecode2-country/regioncode2. languagecode2 is a  lowercase two-letter code derived from ISO 639-1. country/regioncode2 is derived from  ISO 3166 and usually consists of two uppercase letters, or a BCP-47 language tag.
   * @type {string}
   * @memberof ILanguage
   */
  name: string;
}

/**
 * DocumentApi - axios parameter creator
 * @export
 */
export const DocumentApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Returns the actual document data to render, not the entire class.  The path will look at blob {customerId}/{path}
     * @summary Get the document at the specified path.
     * @param {string} [path]
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentDataGet: async (
      path?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/Document/Data`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (path !== undefined) {
        localVarQueryParameter["path"] = path;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: documents_delete
     * @summary Delete a document. The document will be marked as Deleted.
     * @param {string} documentId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentDocumentIdDelete: async (
      documentId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'documentId' is not null or undefined
      assertParamExists(
        "userApiDocumentDocumentIdDelete",
        "documentId",
        documentId
      );
      const localVarPath = `/UserApi/Document/{documentId}`.replace(
        `{${"documentId"}}`,
        encodeURIComponent(String(documentId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: documents_read<para></para>  Partitioned per customer
     * @summary Get document by id
     * @param {string} documentId
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentDocumentIdGet: async (
      documentId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'documentId' is not null or undefined
      assertParamExists(
        "userApiDocumentDocumentIdGet",
        "documentId",
        documentId
      );
      const localVarPath = `/UserApi/Document/{documentId}`.replace(
        `{${"documentId"}}`,
        encodeURIComponent(String(documentId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: documents_edit
     * @summary Create or edit document
     * @param {string} documentId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IDocumentDto} [iDocumentDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentDocumentIdPut: async (
      documentId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iDocumentDto?: IDocumentDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'documentId' is not null or undefined
      assertParamExists(
        "userApiDocumentDocumentIdPut",
        "documentId",
        documentId
      );
      const localVarPath = `/UserApi/Document/{documentId}`.replace(
        `{${"documentId"}}`,
        encodeURIComponent(String(documentId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iDocumentDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: documents_read<para></para>  Partitioned per customer
     * @summary Get all documents
     * @param {boolean} [renewAccess] The URL to the document may be expired. Set to true if the URL access should be renewed.
     * @param {IDocumentGroup} [documentGroup] Documents that belong to a group.
     * @param {boolean} [deleted] null: get all, true: get deleted, false: get active
     * @param {number} [maxItemCount] The maximum number of items to be retrieved
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentGet: async (
      renewAccess?: boolean,
      documentGroup?: IDocumentGroup,
      deleted?: boolean,
      maxItemCount?: number,
      continuationToken?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/Document`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (renewAccess !== undefined) {
        localVarQueryParameter["renewAccess"] = renewAccess;
      }

      if (documentGroup !== undefined) {
        localVarQueryParameter["documentGroup"] = documentGroup;
      }

      if (deleted !== undefined) {
        localVarQueryParameter["deleted"] = deleted;
      }

      if (maxItemCount !== undefined) {
        localVarQueryParameter["maxItemCount"] = maxItemCount;
      }

      if (continuationToken !== undefined) {
        localVarQueryParameter["continuationToken"] = continuationToken;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: documents_create
     * @summary Create document
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IDocumentDto} [iDocumentDto] Document to create. Document.Id is generated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentPost: async (
      apiVersion?: string,
      acceptLanguage?: string,
      iDocumentDto?: IDocumentDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/Document`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iDocumentDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: documents_create
     * @summary Create a document revision
     * @param {string} documentId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IDocumentRevisionDto} [iDocumentRevisionDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentRevisionDocumentIdPost: async (
      documentId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iDocumentRevisionDto?: IDocumentRevisionDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'documentId' is not null or undefined
      assertParamExists(
        "userApiDocumentRevisionDocumentIdPost",
        "documentId",
        documentId
      );
      const localVarPath = `/UserApi/Document/Revision/{documentId}`.replace(
        `{${"documentId"}}`,
        encodeURIComponent(String(documentId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iDocumentRevisionDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: documents_read
     * @summary Get document revision by document id and revision id
     * @param {string} documentId
     * @param {string} revisionId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentRevisionDocumentIdRevisionIdGet: async (
      documentId: string,
      revisionId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'documentId' is not null or undefined
      assertParamExists(
        "userApiDocumentRevisionDocumentIdRevisionIdGet",
        "documentId",
        documentId
      );
      // verify required parameter 'revisionId' is not null or undefined
      assertParamExists(
        "userApiDocumentRevisionDocumentIdRevisionIdGet",
        "revisionId",
        revisionId
      );
      const localVarPath =
        `/UserApi/Document/Revision/{documentId}/{revisionId}`
          .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
          .replace(`{${"revisionId"}}`, encodeURIComponent(String(revisionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: documents_edit
     * @summary Create or update a document
     * @param {string} documentId
     * @param {string} revisionId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IDocumentRevisionDto} [iDocumentRevisionDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentRevisionDocumentIdRevisionIdPut: async (
      documentId: string,
      revisionId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iDocumentRevisionDto?: IDocumentRevisionDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'documentId' is not null or undefined
      assertParamExists(
        "userApiDocumentRevisionDocumentIdRevisionIdPut",
        "documentId",
        documentId
      );
      // verify required parameter 'revisionId' is not null or undefined
      assertParamExists(
        "userApiDocumentRevisionDocumentIdRevisionIdPut",
        "revisionId",
        revisionId
      );
      const localVarPath =
        `/UserApi/Document/Revision/{documentId}/{revisionId}`
          .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
          .replace(`{${"revisionId"}}`, encodeURIComponent(String(revisionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iDocumentRevisionDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Returns the actual document data to render, not the entire class
     * @summary Get the latest revision of document.
     * @param {string} documentId
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentRevisionLatestDataDocumentIdGet: async (
      documentId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'documentId' is not null or undefined
      assertParamExists(
        "userApiDocumentRevisionLatestDataDocumentIdGet",
        "documentId",
        documentId
      );
      const localVarPath =
        `/UserApi/Document/Revision/Latest/Data/{documentId}`.replace(
          `{${"documentId"}}`,
          encodeURIComponent(String(documentId))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DocumentApi - functional programming interface
 * @export
 */
export const DocumentApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DocumentApiAxiosParamCreator(configuration);
  return {
    /**
     * Returns the actual document data to render, not the entire class.  The path will look at blob {customerId}/{path}
     * @summary Get the document at the specified path.
     * @param {string} [path]
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiDocumentDataGet(
      path?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IDocumentIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiDocumentDataGet(
          path,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: documents_delete
     * @summary Delete a document. The document will be marked as Deleted.
     * @param {string} documentId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiDocumentDocumentIdDelete(
      documentId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IDocumentIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiDocumentDocumentIdDelete(
          documentId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: documents_read<para></para>  Partitioned per customer
     * @summary Get document by id
     * @param {string} documentId
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiDocumentDocumentIdGet(
      documentId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IDocumentIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiDocumentDocumentIdGet(
          documentId,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: documents_edit
     * @summary Create or edit document
     * @param {string} documentId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IDocumentDto} [iDocumentDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiDocumentDocumentIdPut(
      documentId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iDocumentDto?: IDocumentDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IDocumentIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiDocumentDocumentIdPut(
          documentId,
          apiVersion,
          acceptLanguage,
          iDocumentDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: documents_read<para></para>  Partitioned per customer
     * @summary Get all documents
     * @param {boolean} [renewAccess] The URL to the document may be expired. Set to true if the URL access should be renewed.
     * @param {IDocumentGroup} [documentGroup] Documents that belong to a group.
     * @param {boolean} [deleted] null: get all, true: get deleted, false: get active
     * @param {number} [maxItemCount] The maximum number of items to be retrieved
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiDocumentGet(
      renewAccess?: boolean,
      documentGroup?: IDocumentGroup,
      deleted?: boolean,
      maxItemCount?: number,
      continuationToken?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IDocumentIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiDocumentGet(
          renewAccess,
          documentGroup,
          deleted,
          maxItemCount,
          continuationToken,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: documents_create
     * @summary Create document
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IDocumentDto} [iDocumentDto] Document to create. Document.Id is generated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiDocumentPost(
      apiVersion?: string,
      acceptLanguage?: string,
      iDocumentDto?: IDocumentDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IDocumentIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiDocumentPost(
          apiVersion,
          acceptLanguage,
          iDocumentDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: documents_create
     * @summary Create a document revision
     * @param {string} documentId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IDocumentRevisionDto} [iDocumentRevisionDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiDocumentRevisionDocumentIdPost(
      documentId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iDocumentRevisionDto?: IDocumentRevisionDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IDocumentIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiDocumentRevisionDocumentIdPost(
          documentId,
          apiVersion,
          acceptLanguage,
          iDocumentRevisionDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: documents_read
     * @summary Get document revision by document id and revision id
     * @param {string} documentId
     * @param {string} revisionId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiDocumentRevisionDocumentIdRevisionIdGet(
      documentId: string,
      revisionId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IDocumentRevisionIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiDocumentRevisionDocumentIdRevisionIdGet(
          documentId,
          revisionId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: documents_edit
     * @summary Create or update a document
     * @param {string} documentId
     * @param {string} revisionId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IDocumentRevisionDto} [iDocumentRevisionDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiDocumentRevisionDocumentIdRevisionIdPut(
      documentId: string,
      revisionId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iDocumentRevisionDto?: IDocumentRevisionDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IDocumentIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiDocumentRevisionDocumentIdRevisionIdPut(
          documentId,
          revisionId,
          apiVersion,
          acceptLanguage,
          iDocumentRevisionDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Returns the actual document data to render, not the entire class
     * @summary Get the latest revision of document.
     * @param {string} documentId
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiDocumentRevisionLatestDataDocumentIdGet(
      documentId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IDocumentIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiDocumentRevisionLatestDataDocumentIdGet(
          documentId,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * DocumentApi - factory interface
 * @export
 */
export const DocumentApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = DocumentApiFp(configuration);
  return {
    /**
     * Returns the actual document data to render, not the entire class.  The path will look at blob {customerId}/{path}
     * @summary Get the document at the specified path.
     * @param {string} [path]
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentDataGet(
      path?: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IDocumentIRadianseResultSuccess> {
      return localVarFp
        .userApiDocumentDataGet(
          path,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: documents_delete
     * @summary Delete a document. The document will be marked as Deleted.
     * @param {string} documentId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentDocumentIdDelete(
      documentId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IDocumentIRadianseResultSuccess> {
      return localVarFp
        .userApiDocumentDocumentIdDelete(
          documentId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: documents_read<para></para>  Partitioned per customer
     * @summary Get document by id
     * @param {string} documentId
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentDocumentIdGet(
      documentId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IDocumentIRadianseResultSuccess> {
      return localVarFp
        .userApiDocumentDocumentIdGet(
          documentId,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: documents_edit
     * @summary Create or edit document
     * @param {string} documentId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IDocumentDto} [iDocumentDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentDocumentIdPut(
      documentId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iDocumentDto?: IDocumentDto,
      options?: any
    ): AxiosPromise<IDocumentIRadianseResultSuccess> {
      return localVarFp
        .userApiDocumentDocumentIdPut(
          documentId,
          apiVersion,
          acceptLanguage,
          iDocumentDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: documents_read<para></para>  Partitioned per customer
     * @summary Get all documents
     * @param {boolean} [renewAccess] The URL to the document may be expired. Set to true if the URL access should be renewed.
     * @param {IDocumentGroup} [documentGroup] Documents that belong to a group.
     * @param {boolean} [deleted] null: get all, true: get deleted, false: get active
     * @param {number} [maxItemCount] The maximum number of items to be retrieved
     * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentGet(
      renewAccess?: boolean,
      documentGroup?: IDocumentGroup,
      deleted?: boolean,
      maxItemCount?: number,
      continuationToken?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IDocumentIRadianseResultSuccess> {
      return localVarFp
        .userApiDocumentGet(
          renewAccess,
          documentGroup,
          deleted,
          maxItemCount,
          continuationToken,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: documents_create
     * @summary Create document
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IDocumentDto} [iDocumentDto] Document to create. Document.Id is generated.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentPost(
      apiVersion?: string,
      acceptLanguage?: string,
      iDocumentDto?: IDocumentDto,
      options?: any
    ): AxiosPromise<IDocumentIRadianseResultSuccess> {
      return localVarFp
        .userApiDocumentPost(apiVersion, acceptLanguage, iDocumentDto, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: documents_create
     * @summary Create a document revision
     * @param {string} documentId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IDocumentRevisionDto} [iDocumentRevisionDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentRevisionDocumentIdPost(
      documentId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iDocumentRevisionDto?: IDocumentRevisionDto,
      options?: any
    ): AxiosPromise<IDocumentIRadianseResultSuccess> {
      return localVarFp
        .userApiDocumentRevisionDocumentIdPost(
          documentId,
          apiVersion,
          acceptLanguage,
          iDocumentRevisionDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: documents_read
     * @summary Get document revision by document id and revision id
     * @param {string} documentId
     * @param {string} revisionId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentRevisionDocumentIdRevisionIdGet(
      documentId: string,
      revisionId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IDocumentRevisionIRadianseResultSuccess> {
      return localVarFp
        .userApiDocumentRevisionDocumentIdRevisionIdGet(
          documentId,
          revisionId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: documents_edit
     * @summary Create or update a document
     * @param {string} documentId
     * @param {string} revisionId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IDocumentRevisionDto} [iDocumentRevisionDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentRevisionDocumentIdRevisionIdPut(
      documentId: string,
      revisionId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iDocumentRevisionDto?: IDocumentRevisionDto,
      options?: any
    ): AxiosPromise<IDocumentIRadianseResultSuccess> {
      return localVarFp
        .userApiDocumentRevisionDocumentIdRevisionIdPut(
          documentId,
          revisionId,
          apiVersion,
          acceptLanguage,
          iDocumentRevisionDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Returns the actual document data to render, not the entire class
     * @summary Get the latest revision of document.
     * @param {string} documentId
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentRevisionLatestDataDocumentIdGet(
      documentId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IDocumentIRadianseResultSuccess> {
      return localVarFp
        .userApiDocumentRevisionLatestDataDocumentIdGet(
          documentId,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * DocumentApi - object-oriented interface
 * @export
 * @class DocumentApi
 * @extends {BaseAPI}
 */
export class DocumentApi extends BaseAPI {
  /**
   * Returns the actual document data to render, not the entire class.  The path will look at blob {customerId}/{path}
   * @summary Get the document at the specified path.
   * @param {string} [path]
   * @param {string} [groupId] GroupId is required if using a bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public userApiDocumentDataGet(
    path?: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return DocumentApiFp(this.configuration)
      .userApiDocumentDataGet(
        path,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: documents_delete
   * @summary Delete a document. The document will be marked as Deleted.
   * @param {string} documentId
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public userApiDocumentDocumentIdDelete(
    documentId: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return DocumentApiFp(this.configuration)
      .userApiDocumentDocumentIdDelete(
        documentId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: documents_read<para></para>  Partitioned per customer
   * @summary Get document by id
   * @param {string} documentId
   * @param {string} [groupId] GroupId is required if using a bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public userApiDocumentDocumentIdGet(
    documentId: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return DocumentApiFp(this.configuration)
      .userApiDocumentDocumentIdGet(
        documentId,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: documents_edit
   * @summary Create or edit document
   * @param {string} documentId
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IDocumentDto} [iDocumentDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public userApiDocumentDocumentIdPut(
    documentId: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iDocumentDto?: IDocumentDto,
    options?: AxiosRequestConfig
  ) {
    return DocumentApiFp(this.configuration)
      .userApiDocumentDocumentIdPut(
        documentId,
        apiVersion,
        acceptLanguage,
        iDocumentDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: documents_read<para></para>  Partitioned per customer
   * @summary Get all documents
   * @param {boolean} [renewAccess] The URL to the document may be expired. Set to true if the URL access should be renewed.
   * @param {IDocumentGroup} [documentGroup] Documents that belong to a group.
   * @param {boolean} [deleted] null: get all, true: get deleted, false: get active
   * @param {number} [maxItemCount] The maximum number of items to be retrieved
   * @param {string} [continuationToken] If not null, continues to retrieve the next x items from the last request
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public userApiDocumentGet(
    renewAccess?: boolean,
    documentGroup?: IDocumentGroup,
    deleted?: boolean,
    maxItemCount?: number,
    continuationToken?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return DocumentApiFp(this.configuration)
      .userApiDocumentGet(
        renewAccess,
        documentGroup,
        deleted,
        maxItemCount,
        continuationToken,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: documents_create
   * @summary Create document
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IDocumentDto} [iDocumentDto] Document to create. Document.Id is generated.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public userApiDocumentPost(
    apiVersion?: string,
    acceptLanguage?: string,
    iDocumentDto?: IDocumentDto,
    options?: AxiosRequestConfig
  ) {
    return DocumentApiFp(this.configuration)
      .userApiDocumentPost(apiVersion, acceptLanguage, iDocumentDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: documents_create
   * @summary Create a document revision
   * @param {string} documentId
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IDocumentRevisionDto} [iDocumentRevisionDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public userApiDocumentRevisionDocumentIdPost(
    documentId: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iDocumentRevisionDto?: IDocumentRevisionDto,
    options?: AxiosRequestConfig
  ) {
    return DocumentApiFp(this.configuration)
      .userApiDocumentRevisionDocumentIdPost(
        documentId,
        apiVersion,
        acceptLanguage,
        iDocumentRevisionDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: documents_read
   * @summary Get document revision by document id and revision id
   * @param {string} documentId
   * @param {string} revisionId
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public userApiDocumentRevisionDocumentIdRevisionIdGet(
    documentId: string,
    revisionId: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return DocumentApiFp(this.configuration)
      .userApiDocumentRevisionDocumentIdRevisionIdGet(
        documentId,
        revisionId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: documents_edit
   * @summary Create or update a document
   * @param {string} documentId
   * @param {string} revisionId
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IDocumentRevisionDto} [iDocumentRevisionDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public userApiDocumentRevisionDocumentIdRevisionIdPut(
    documentId: string,
    revisionId: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iDocumentRevisionDto?: IDocumentRevisionDto,
    options?: AxiosRequestConfig
  ) {
    return DocumentApiFp(this.configuration)
      .userApiDocumentRevisionDocumentIdRevisionIdPut(
        documentId,
        revisionId,
        apiVersion,
        acceptLanguage,
        iDocumentRevisionDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Returns the actual document data to render, not the entire class
   * @summary Get the latest revision of document.
   * @param {string} documentId
   * @param {string} [groupId] GroupId is required if using a bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentApi
   */
  public userApiDocumentRevisionLatestDataDocumentIdGet(
    documentId: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return DocumentApiFp(this.configuration)
      .userApiDocumentRevisionLatestDataDocumentIdGet(
        documentId,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * DocumentSigningApi - axios parameter creator
 * @export
 */
export const DocumentSigningApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: documentssigning_delete
     * @summary Delete a signed document
     * @param {string} personId
     * @param {string} documentId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentSigningPersonIdDocumentIdDelete: async (
      personId: string,
      documentId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'personId' is not null or undefined
      assertParamExists(
        "userApiDocumentSigningPersonIdDocumentIdDelete",
        "personId",
        personId
      );
      // verify required parameter 'documentId' is not null or undefined
      assertParamExists(
        "userApiDocumentSigningPersonIdDocumentIdDelete",
        "documentId",
        documentId
      );
      const localVarPath = `/UserApi/DocumentSigning/{personId}/{documentId}`
        .replace(`{${"personId"}}`, encodeURIComponent(String(personId)))
        .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: documentssigning_read<para></para>  Partitioned by personId.
     * @summary Get document signing
     * @param {string} personId
     * @param {string} documentId
     * @param {boolean} [calculateSuccess] True: Call will determine if the user has signed the current revision of the document  and set \&quot;Success\&quot; accordingly.  False: Get the document revisions the user signed, don\&#39;t care if they signed the current  active revision of the document.
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentSigningPersonIdDocumentIdGet: async (
      personId: string,
      documentId: string,
      calculateSuccess?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'personId' is not null or undefined
      assertParamExists(
        "userApiDocumentSigningPersonIdDocumentIdGet",
        "personId",
        personId
      );
      // verify required parameter 'documentId' is not null or undefined
      assertParamExists(
        "userApiDocumentSigningPersonIdDocumentIdGet",
        "documentId",
        documentId
      );
      const localVarPath = `/UserApi/DocumentSigning/{personId}/{documentId}`
        .replace(`{${"personId"}}`, encodeURIComponent(String(personId)))
        .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (calculateSuccess !== undefined) {
        localVarQueryParameter["calculateSuccess"] = calculateSuccess;
      }

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete a signed document revision
     * @param {string} personId
     * @param {string} documentId
     * @param {string} revisionId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentSigningPersonIdDocumentIdRevisionIdDelete: async (
      personId: string,
      documentId: string,
      revisionId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'personId' is not null or undefined
      assertParamExists(
        "userApiDocumentSigningPersonIdDocumentIdRevisionIdDelete",
        "personId",
        personId
      );
      // verify required parameter 'documentId' is not null or undefined
      assertParamExists(
        "userApiDocumentSigningPersonIdDocumentIdRevisionIdDelete",
        "documentId",
        documentId
      );
      // verify required parameter 'revisionId' is not null or undefined
      assertParamExists(
        "userApiDocumentSigningPersonIdDocumentIdRevisionIdDelete",
        "revisionId",
        revisionId
      );
      const localVarPath =
        `/UserApi/DocumentSigning/{personId}/{documentId}/{revisionId}`
          .replace(`{${"personId"}}`, encodeURIComponent(String(personId)))
          .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
          .replace(`{${"revisionId"}}`, encodeURIComponent(String(revisionId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all document signings a person has signed
     * @param {string} personId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentSigningPersonIdGet: async (
      personId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'personId' is not null or undefined
      assertParamExists(
        "userApiDocumentSigningPersonIdGet",
        "personId",
        personId
      );
      const localVarPath = `/UserApi/DocumentSigning/{personId}`.replace(
        `{${"personId"}}`,
        encodeURIComponent(String(personId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: documentssigning_create                This endpoint creates a signed document using the person\'s information associated with the personId passed in.  It assumes the caller is displaying the latest revision to the person and that person is signing the document.
     * @summary Sign the latest revision of the document.
     * @param {string} personId The person\&#39;s id
     * @param {string} personPartitionKey The partition key of the person
     * @param {string} documentId
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentSigningRevisionLatestPersonIdPersonPartitionKeyDocumentIdPut:
      async (
        personId: string,
        personPartitionKey: string,
        documentId: string,
        groupId?: string,
        tenantId?: string,
        apiVersion?: string,
        acceptLanguage?: string,
        options: AxiosRequestConfig = {}
      ): Promise<RequestArgs> => {
        // verify required parameter 'personId' is not null or undefined
        assertParamExists(
          "userApiDocumentSigningRevisionLatestPersonIdPersonPartitionKeyDocumentIdPut",
          "personId",
          personId
        );
        // verify required parameter 'personPartitionKey' is not null or undefined
        assertParamExists(
          "userApiDocumentSigningRevisionLatestPersonIdPersonPartitionKeyDocumentIdPut",
          "personPartitionKey",
          personPartitionKey
        );
        // verify required parameter 'documentId' is not null or undefined
        assertParamExists(
          "userApiDocumentSigningRevisionLatestPersonIdPersonPartitionKeyDocumentIdPut",
          "documentId",
          documentId
        );
        const localVarPath =
          `/UserApi/DocumentSigning/Revision/Latest/{personId}/{personPartitionKey}/{documentId}`
            .replace(`{${"personId"}}`, encodeURIComponent(String(personId)))
            .replace(
              `{${"personPartitionKey"}}`,
              encodeURIComponent(String(personPartitionKey))
            )
            .replace(
              `{${"documentId"}}`,
              encodeURIComponent(String(documentId))
            );
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "PUT",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // authentication Bearer required
        await setApiKeyToObject(
          localVarHeaderParameter,
          "Authorization",
          configuration
        );

        if (groupId !== undefined) {
          localVarQueryParameter["groupId"] = groupId;
        }

        if (tenantId !== undefined) {
          localVarQueryParameter["tenantId"] = tenantId;
        }

        if (apiVersion !== undefined) {
          localVarQueryParameter["api-version"] = apiVersion;
        }

        if (acceptLanguage != null) {
          localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
        }

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
    /**
     * Permission: documentssigning_create
     * @summary PUT documentSigning
     * @param {string} personId The person\&#39;s id
     * @param {string} personPartitionKey The partition key of the person
     * @param {string} documentId Document id
     * @param {string} revisionId There may be multiple revisions of Document.Id. DocumentRevisionId points the               Document.Revisions.Id the person signed. The Document class has a list of document revisions
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IDocumentRevisionSigningDto} [iDocumentRevisionSigningDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentSigningRevisionPersonIdPersonPartitionKeyDocumentIdRevisionIdPut:
      async (
        personId: string,
        personPartitionKey: string,
        documentId: string,
        revisionId: string,
        apiVersion?: string,
        acceptLanguage?: string,
        iDocumentRevisionSigningDto?: IDocumentRevisionSigningDto,
        options: AxiosRequestConfig = {}
      ): Promise<RequestArgs> => {
        // verify required parameter 'personId' is not null or undefined
        assertParamExists(
          "userApiDocumentSigningRevisionPersonIdPersonPartitionKeyDocumentIdRevisionIdPut",
          "personId",
          personId
        );
        // verify required parameter 'personPartitionKey' is not null or undefined
        assertParamExists(
          "userApiDocumentSigningRevisionPersonIdPersonPartitionKeyDocumentIdRevisionIdPut",
          "personPartitionKey",
          personPartitionKey
        );
        // verify required parameter 'documentId' is not null or undefined
        assertParamExists(
          "userApiDocumentSigningRevisionPersonIdPersonPartitionKeyDocumentIdRevisionIdPut",
          "documentId",
          documentId
        );
        // verify required parameter 'revisionId' is not null or undefined
        assertParamExists(
          "userApiDocumentSigningRevisionPersonIdPersonPartitionKeyDocumentIdRevisionIdPut",
          "revisionId",
          revisionId
        );
        const localVarPath =
          `/UserApi/DocumentSigning/Revision/{personId}/{personPartitionKey}/{documentId}/{revisionId}`
            .replace(`{${"personId"}}`, encodeURIComponent(String(personId)))
            .replace(
              `{${"personPartitionKey"}}`,
              encodeURIComponent(String(personPartitionKey))
            )
            .replace(
              `{${"documentId"}}`,
              encodeURIComponent(String(documentId))
            )
            .replace(
              `{${"revisionId"}}`,
              encodeURIComponent(String(revisionId))
            );
        // use dummy base URL string because the URL constructor only accepts absolute URLs.
        const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
        let baseOptions;
        if (configuration) {
          baseOptions = configuration.baseOptions;
        }

        const localVarRequestOptions = {
          method: "PUT",
          ...baseOptions,
          ...options,
        };
        const localVarHeaderParameter = {} as any;
        const localVarQueryParameter = {} as any;

        // authentication Bearer required
        await setApiKeyToObject(
          localVarHeaderParameter,
          "Authorization",
          configuration
        );

        if (apiVersion !== undefined) {
          localVarQueryParameter["api-version"] = apiVersion;
        }

        if (acceptLanguage != null) {
          localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
        }

        localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

        setSearchParams(localVarUrlObj, localVarQueryParameter);
        let headersFromBaseOptions =
          baseOptions && baseOptions.headers ? baseOptions.headers : {};
        localVarRequestOptions.headers = {
          ...localVarHeaderParameter,
          ...headersFromBaseOptions,
          ...options.headers,
        };
        localVarRequestOptions.data = serializeDataIfNeeded(
          iDocumentRevisionSigningDto,
          localVarRequestOptions,
          configuration
        );

        return {
          url: toPathString(localVarUrlObj),
          options: localVarRequestOptions,
        };
      },
  };
};

/**
 * DocumentSigningApi - functional programming interface
 * @export
 */
export const DocumentSigningApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    DocumentSigningApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: documentssigning_delete
     * @summary Delete a signed document
     * @param {string} personId
     * @param {string} documentId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiDocumentSigningPersonIdDocumentIdDelete(
      personId: string,
      documentId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IDocumentRevisionSigningIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiDocumentSigningPersonIdDocumentIdDelete(
          personId,
          documentId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: documentssigning_read<para></para>  Partitioned by personId.
     * @summary Get document signing
     * @param {string} personId
     * @param {string} documentId
     * @param {boolean} [calculateSuccess] True: Call will determine if the user has signed the current revision of the document  and set \&quot;Success\&quot; accordingly.  False: Get the document revisions the user signed, don\&#39;t care if they signed the current  active revision of the document.
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiDocumentSigningPersonIdDocumentIdGet(
      personId: string,
      documentId: string,
      calculateSuccess?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IDocumentSigningIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiDocumentSigningPersonIdDocumentIdGet(
          personId,
          documentId,
          calculateSuccess,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Delete a signed document revision
     * @param {string} personId
     * @param {string} documentId
     * @param {string} revisionId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiDocumentSigningPersonIdDocumentIdRevisionIdDelete(
      personId: string,
      documentId: string,
      revisionId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IDocumentRevisionSigningIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiDocumentSigningPersonIdDocumentIdRevisionIdDelete(
          personId,
          documentId,
          revisionId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Get all document signings a person has signed
     * @param {string} personId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiDocumentSigningPersonIdGet(
      personId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IDocumentSigningListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiDocumentSigningPersonIdGet(
          personId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: documentssigning_create                This endpoint creates a signed document using the person\'s information associated with the personId passed in.  It assumes the caller is displaying the latest revision to the person and that person is signing the document.
     * @summary Sign the latest revision of the document.
     * @param {string} personId The person\&#39;s id
     * @param {string} personPartitionKey The partition key of the person
     * @param {string} documentId
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiDocumentSigningRevisionLatestPersonIdPersonPartitionKeyDocumentIdPut(
      personId: string,
      personPartitionKey: string,
      documentId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IDocumentRevisionSigningIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiDocumentSigningRevisionLatestPersonIdPersonPartitionKeyDocumentIdPut(
          personId,
          personPartitionKey,
          documentId,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: documentssigning_create
     * @summary PUT documentSigning
     * @param {string} personId The person\&#39;s id
     * @param {string} personPartitionKey The partition key of the person
     * @param {string} documentId Document id
     * @param {string} revisionId There may be multiple revisions of Document.Id. DocumentRevisionId points the               Document.Revisions.Id the person signed. The Document class has a list of document revisions
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IDocumentRevisionSigningDto} [iDocumentRevisionSigningDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiDocumentSigningRevisionPersonIdPersonPartitionKeyDocumentIdRevisionIdPut(
      personId: string,
      personPartitionKey: string,
      documentId: string,
      revisionId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iDocumentRevisionSigningDto?: IDocumentRevisionSigningDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IDocumentRevisionSigningIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiDocumentSigningRevisionPersonIdPersonPartitionKeyDocumentIdRevisionIdPut(
          personId,
          personPartitionKey,
          documentId,
          revisionId,
          apiVersion,
          acceptLanguage,
          iDocumentRevisionSigningDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * DocumentSigningApi - factory interface
 * @export
 */
export const DocumentSigningApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = DocumentSigningApiFp(configuration);
  return {
    /**
     * Permission: documentssigning_delete
     * @summary Delete a signed document
     * @param {string} personId
     * @param {string} documentId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentSigningPersonIdDocumentIdDelete(
      personId: string,
      documentId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IDocumentRevisionSigningIRadianseResultSuccess> {
      return localVarFp
        .userApiDocumentSigningPersonIdDocumentIdDelete(
          personId,
          documentId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: documentssigning_read<para></para>  Partitioned by personId.
     * @summary Get document signing
     * @param {string} personId
     * @param {string} documentId
     * @param {boolean} [calculateSuccess] True: Call will determine if the user has signed the current revision of the document  and set \&quot;Success\&quot; accordingly.  False: Get the document revisions the user signed, don\&#39;t care if they signed the current  active revision of the document.
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentSigningPersonIdDocumentIdGet(
      personId: string,
      documentId: string,
      calculateSuccess?: boolean,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IDocumentSigningIRadianseResultSuccess> {
      return localVarFp
        .userApiDocumentSigningPersonIdDocumentIdGet(
          personId,
          documentId,
          calculateSuccess,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete a signed document revision
     * @param {string} personId
     * @param {string} documentId
     * @param {string} revisionId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentSigningPersonIdDocumentIdRevisionIdDelete(
      personId: string,
      documentId: string,
      revisionId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IDocumentRevisionSigningIRadianseResultSuccess> {
      return localVarFp
        .userApiDocumentSigningPersonIdDocumentIdRevisionIdDelete(
          personId,
          documentId,
          revisionId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all document signings a person has signed
     * @param {string} personId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentSigningPersonIdGet(
      personId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IDocumentSigningListIRadianseResultSuccess> {
      return localVarFp
        .userApiDocumentSigningPersonIdGet(
          personId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: documentssigning_create                This endpoint creates a signed document using the person\'s information associated with the personId passed in.  It assumes the caller is displaying the latest revision to the person and that person is signing the document.
     * @summary Sign the latest revision of the document.
     * @param {string} personId The person\&#39;s id
     * @param {string} personPartitionKey The partition key of the person
     * @param {string} documentId
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentSigningRevisionLatestPersonIdPersonPartitionKeyDocumentIdPut(
      personId: string,
      personPartitionKey: string,
      documentId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IDocumentRevisionSigningIRadianseResultSuccess> {
      return localVarFp
        .userApiDocumentSigningRevisionLatestPersonIdPersonPartitionKeyDocumentIdPut(
          personId,
          personPartitionKey,
          documentId,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: documentssigning_create
     * @summary PUT documentSigning
     * @param {string} personId The person\&#39;s id
     * @param {string} personPartitionKey The partition key of the person
     * @param {string} documentId Document id
     * @param {string} revisionId There may be multiple revisions of Document.Id. DocumentRevisionId points the               Document.Revisions.Id the person signed. The Document class has a list of document revisions
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IDocumentRevisionSigningDto} [iDocumentRevisionSigningDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiDocumentSigningRevisionPersonIdPersonPartitionKeyDocumentIdRevisionIdPut(
      personId: string,
      personPartitionKey: string,
      documentId: string,
      revisionId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      iDocumentRevisionSigningDto?: IDocumentRevisionSigningDto,
      options?: any
    ): AxiosPromise<IDocumentRevisionSigningIRadianseResultSuccess> {
      return localVarFp
        .userApiDocumentSigningRevisionPersonIdPersonPartitionKeyDocumentIdRevisionIdPut(
          personId,
          personPartitionKey,
          documentId,
          revisionId,
          apiVersion,
          acceptLanguage,
          iDocumentRevisionSigningDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * DocumentSigningApi - object-oriented interface
 * @export
 * @class DocumentSigningApi
 * @extends {BaseAPI}
 */
export class DocumentSigningApi extends BaseAPI {
  /**
   * Permission: documentssigning_delete
   * @summary Delete a signed document
   * @param {string} personId
   * @param {string} documentId
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentSigningApi
   */
  public userApiDocumentSigningPersonIdDocumentIdDelete(
    personId: string,
    documentId: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return DocumentSigningApiFp(this.configuration)
      .userApiDocumentSigningPersonIdDocumentIdDelete(
        personId,
        documentId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: documentssigning_read<para></para>  Partitioned by personId.
   * @summary Get document signing
   * @param {string} personId
   * @param {string} documentId
   * @param {boolean} [calculateSuccess] True: Call will determine if the user has signed the current revision of the document  and set \&quot;Success\&quot; accordingly.  False: Get the document revisions the user signed, don\&#39;t care if they signed the current  active revision of the document.
   * @param {string} [groupId] GroupId is required if using a bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentSigningApi
   */
  public userApiDocumentSigningPersonIdDocumentIdGet(
    personId: string,
    documentId: string,
    calculateSuccess?: boolean,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return DocumentSigningApiFp(this.configuration)
      .userApiDocumentSigningPersonIdDocumentIdGet(
        personId,
        documentId,
        calculateSuccess,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete a signed document revision
   * @param {string} personId
   * @param {string} documentId
   * @param {string} revisionId
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentSigningApi
   */
  public userApiDocumentSigningPersonIdDocumentIdRevisionIdDelete(
    personId: string,
    documentId: string,
    revisionId: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return DocumentSigningApiFp(this.configuration)
      .userApiDocumentSigningPersonIdDocumentIdRevisionIdDelete(
        personId,
        documentId,
        revisionId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all document signings a person has signed
   * @param {string} personId
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentSigningApi
   */
  public userApiDocumentSigningPersonIdGet(
    personId: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return DocumentSigningApiFp(this.configuration)
      .userApiDocumentSigningPersonIdGet(
        personId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: documentssigning_create                This endpoint creates a signed document using the person\'s information associated with the personId passed in.  It assumes the caller is displaying the latest revision to the person and that person is signing the document.
   * @summary Sign the latest revision of the document.
   * @param {string} personId The person\&#39;s id
   * @param {string} personPartitionKey The partition key of the person
   * @param {string} documentId
   * @param {string} [groupId] GroupId is required if using a bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentSigningApi
   */
  public userApiDocumentSigningRevisionLatestPersonIdPersonPartitionKeyDocumentIdPut(
    personId: string,
    personPartitionKey: string,
    documentId: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return DocumentSigningApiFp(this.configuration)
      .userApiDocumentSigningRevisionLatestPersonIdPersonPartitionKeyDocumentIdPut(
        personId,
        personPartitionKey,
        documentId,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: documentssigning_create
   * @summary PUT documentSigning
   * @param {string} personId The person\&#39;s id
   * @param {string} personPartitionKey The partition key of the person
   * @param {string} documentId Document id
   * @param {string} revisionId There may be multiple revisions of Document.Id. DocumentRevisionId points the               Document.Revisions.Id the person signed. The Document class has a list of document revisions
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IDocumentRevisionSigningDto} [iDocumentRevisionSigningDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DocumentSigningApi
   */
  public userApiDocumentSigningRevisionPersonIdPersonPartitionKeyDocumentIdRevisionIdPut(
    personId: string,
    personPartitionKey: string,
    documentId: string,
    revisionId: string,
    apiVersion?: string,
    acceptLanguage?: string,
    iDocumentRevisionSigningDto?: IDocumentRevisionSigningDto,
    options?: AxiosRequestConfig
  ) {
    return DocumentSigningApiFp(this.configuration)
      .userApiDocumentSigningRevisionPersonIdPersonPartitionKeyDocumentIdRevisionIdPut(
        personId,
        personPartitionKey,
        documentId,
        revisionId,
        apiVersion,
        acceptLanguage,
        iDocumentRevisionSigningDto,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * RequestContextApi - axios parameter creator
 * @export
 */
export const RequestContextApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequestContextGet: async (
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/RequestContext`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RequestContextApi - functional programming interface
 * @export
 */
export const RequestContextApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    RequestContextApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiRequestContextGet(
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IIRadianseRequestContext>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiRequestContextGet(
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * RequestContextApi - factory interface
 * @export
 */
export const RequestContextApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = RequestContextApiFp(configuration);
  return {
    /**
     *
     * @summary
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiRequestContextGet(
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IIRadianseRequestContext> {
      return localVarFp
        .userApiRequestContextGet(apiVersion, acceptLanguage, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * RequestContextApi - object-oriented interface
 * @export
 * @class RequestContextApi
 * @extends {BaseAPI}
 */
export class RequestContextApi extends BaseAPI {
  /**
   *
   * @summary
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RequestContextApi
   */
  public userApiRequestContextGet(
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return RequestContextApiFp(this.configuration)
      .userApiRequestContextGet(apiVersion, acceptLanguage, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * UploadApi - axios parameter creator
 * @export
 */
export const UploadApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Permission: file_read<para></para>  Partitioned by identityId.
     * @summary Get file
     * @param {string} fileId
     * @param {string} identityId
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUploadFileIdIdentityIdGet: async (
      fileId: string,
      identityId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'fileId' is not null or undefined
      assertParamExists("userApiUploadFileIdIdentityIdGet", "fileId", fileId);
      // verify required parameter 'identityId' is not null or undefined
      assertParamExists(
        "userApiUploadFileIdIdentityIdGet",
        "identityId",
        identityId
      );
      const localVarPath = `/UserApi/Upload/{fileId}/{identityId}`
        .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)))
        .replace(`{${"identityId"}}`, encodeURIComponent(String(identityId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (groupId !== undefined) {
        localVarQueryParameter["groupId"] = groupId;
      }

      if (tenantId !== undefined) {
        localVarQueryParameter["tenantId"] = tenantId;
      }

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: file_delete
     * @summary Delete a file
     * @param {string} id ID of the file
     * @param {string} identityId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUploadIdIdentityIdDelete: async (
      id: string,
      identityId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists("userApiUploadIdIdentityIdDelete", "id", id);
      // verify required parameter 'identityId' is not null or undefined
      assertParamExists(
        "userApiUploadIdIdentityIdDelete",
        "identityId",
        identityId
      );
      const localVarPath = `/UserApi/Upload/{id}/{identityId}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)))
        .replace(`{${"identityId"}}`, encodeURIComponent(String(identityId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "DELETE",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all files associated with this identity
     * @param {string} identityId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUploadIdentityIdGet: async (
      identityId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'identityId' is not null or undefined
      assertParamExists("userApiUploadIdentityIdGet", "identityId", identityId);
      const localVarPath = `/UserApi/Upload/{identityId}`.replace(
        `{${"identityId"}}`,
        encodeURIComponent(String(identityId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: file_create
     * @summary POST file
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IFilePropsPostDto} [iFilePropsPostDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUploadPost: async (
      apiVersion?: string,
      acceptLanguage?: string,
      iFilePropsPostDto?: IFilePropsPostDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/Upload`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iFilePropsPostDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * Permission: file_create
     * @summary PUT file
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IFilePropsDto} [iFilePropsDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUploadPut: async (
      apiVersion?: string,
      acceptLanguage?: string,
      iFilePropsDto?: IFilePropsDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/UserApi/Upload`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        "Authorization",
        configuration
      );

      if (apiVersion !== undefined) {
        localVarQueryParameter["api-version"] = apiVersion;
      }

      if (acceptLanguage != null) {
        localVarHeaderParameter["Accept-Language"] = String(acceptLanguage);
      }

      localVarHeaderParameter["Content-Type"] = "application/json-patch+json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        iFilePropsDto,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UploadApi - functional programming interface
 * @export
 */
export const UploadApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = UploadApiAxiosParamCreator(configuration);
  return {
    /**
     * Permission: file_read<para></para>  Partitioned by identityId.
     * @summary Get file
     * @param {string} fileId
     * @param {string} identityId
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiUploadFileIdIdentityIdGet(
      fileId: string,
      identityId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IFilePropsIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiUploadFileIdIdentityIdGet(
          fileId,
          identityId,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: file_delete
     * @summary Delete a file
     * @param {string} id ID of the file
     * @param {string} identityId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiUploadIdIdentityIdDelete(
      id: string,
      identityId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IFilePropsIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiUploadIdIdentityIdDelete(
          id,
          identityId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Get all files associated with this identity
     * @param {string} identityId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiUploadIdentityIdGet(
      identityId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IFilePropsListIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiUploadIdentityIdGet(
          identityId,
          apiVersion,
          acceptLanguage,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: file_create
     * @summary POST file
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IFilePropsPostDto} [iFilePropsPostDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiUploadPost(
      apiVersion?: string,
      acceptLanguage?: string,
      iFilePropsPostDto?: IFilePropsPostDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IFilePropsIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiUploadPost(
          apiVersion,
          acceptLanguage,
          iFilePropsPostDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     * Permission: file_create
     * @summary PUT file
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IFilePropsDto} [iFilePropsDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userApiUploadPut(
      apiVersion?: string,
      acceptLanguage?: string,
      iFilePropsDto?: IFilePropsDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<IFilePropsIRadianseResultSuccess>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.userApiUploadPut(
          apiVersion,
          acceptLanguage,
          iFilePropsDto,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * UploadApi - factory interface
 * @export
 */
export const UploadApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = UploadApiFp(configuration);
  return {
    /**
     * Permission: file_read<para></para>  Partitioned by identityId.
     * @summary Get file
     * @param {string} fileId
     * @param {string} identityId
     * @param {string} [groupId] GroupId is required if using a bearer token.
     * @param {string} [tenantId] TenantId is required if using a bearer token.
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUploadFileIdIdentityIdGet(
      fileId: string,
      identityId: string,
      groupId?: string,
      tenantId?: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IFilePropsIRadianseResultSuccess> {
      return localVarFp
        .userApiUploadFileIdIdentityIdGet(
          fileId,
          identityId,
          groupId,
          tenantId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: file_delete
     * @summary Delete a file
     * @param {string} id ID of the file
     * @param {string} identityId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUploadIdIdentityIdDelete(
      id: string,
      identityId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IFilePropsIRadianseResultSuccess> {
      return localVarFp
        .userApiUploadIdIdentityIdDelete(
          id,
          identityId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all files associated with this identity
     * @param {string} identityId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUploadIdentityIdGet(
      identityId: string,
      apiVersion?: string,
      acceptLanguage?: string,
      options?: any
    ): AxiosPromise<IFilePropsListIRadianseResultSuccess> {
      return localVarFp
        .userApiUploadIdentityIdGet(
          identityId,
          apiVersion,
          acceptLanguage,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: file_create
     * @summary POST file
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IFilePropsPostDto} [iFilePropsPostDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUploadPost(
      apiVersion?: string,
      acceptLanguage?: string,
      iFilePropsPostDto?: IFilePropsPostDto,
      options?: any
    ): AxiosPromise<IFilePropsIRadianseResultSuccess> {
      return localVarFp
        .userApiUploadPost(
          apiVersion,
          acceptLanguage,
          iFilePropsPostDto,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     * Permission: file_create
     * @summary PUT file
     * @param {string} [apiVersion] The requested API version
     * @param {string} [acceptLanguage]
     * @param {IFilePropsDto} [iFilePropsDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userApiUploadPut(
      apiVersion?: string,
      acceptLanguage?: string,
      iFilePropsDto?: IFilePropsDto,
      options?: any
    ): AxiosPromise<IFilePropsIRadianseResultSuccess> {
      return localVarFp
        .userApiUploadPut(apiVersion, acceptLanguage, iFilePropsDto, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * UploadApi - object-oriented interface
 * @export
 * @class UploadApi
 * @extends {BaseAPI}
 */
export class UploadApi extends BaseAPI {
  /**
   * Permission: file_read<para></para>  Partitioned by identityId.
   * @summary Get file
   * @param {string} fileId
   * @param {string} identityId
   * @param {string} [groupId] GroupId is required if using a bearer token.
   * @param {string} [tenantId] TenantId is required if using a bearer token.
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UploadApi
   */
  public userApiUploadFileIdIdentityIdGet(
    fileId: string,
    identityId: string,
    groupId?: string,
    tenantId?: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return UploadApiFp(this.configuration)
      .userApiUploadFileIdIdentityIdGet(
        fileId,
        identityId,
        groupId,
        tenantId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: file_delete
   * @summary Delete a file
   * @param {string} id ID of the file
   * @param {string} identityId
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UploadApi
   */
  public userApiUploadIdIdentityIdDelete(
    id: string,
    identityId: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return UploadApiFp(this.configuration)
      .userApiUploadIdIdentityIdDelete(
        id,
        identityId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all files associated with this identity
   * @param {string} identityId
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UploadApi
   */
  public userApiUploadIdentityIdGet(
    identityId: string,
    apiVersion?: string,
    acceptLanguage?: string,
    options?: AxiosRequestConfig
  ) {
    return UploadApiFp(this.configuration)
      .userApiUploadIdentityIdGet(
        identityId,
        apiVersion,
        acceptLanguage,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: file_create
   * @summary POST file
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IFilePropsPostDto} [iFilePropsPostDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UploadApi
   */
  public userApiUploadPost(
    apiVersion?: string,
    acceptLanguage?: string,
    iFilePropsPostDto?: IFilePropsPostDto,
    options?: AxiosRequestConfig
  ) {
    return UploadApiFp(this.configuration)
      .userApiUploadPost(apiVersion, acceptLanguage, iFilePropsPostDto, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * Permission: file_create
   * @summary PUT file
   * @param {string} [apiVersion] The requested API version
   * @param {string} [acceptLanguage]
   * @param {IFilePropsDto} [iFilePropsDto]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UploadApi
   */
  public userApiUploadPut(
    apiVersion?: string,
    acceptLanguage?: string,
    iFilePropsDto?: IFilePropsDto,
    options?: AxiosRequestConfig
  ) {
    return UploadApiFp(this.configuration)
      .userApiUploadPut(apiVersion, acceptLanguage, iFilePropsDto, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
